import React from 'react';
import ChartBar from '../../../components/ChartBar';
import { PaymentPlatformData, SummedReport } from '../../../models/ReportData';
import useChartTheme from '../../../themes/chart';
import {
  getProductTypeKey,
  isPaidProduct,
  findPricebookReportsByType,
} from '../../../data/report/helpers/pricebookReportUtils';
import { buildReportChartData } from '../../../data/report/helpers/chartUtils';

const paymentPlatformMap = new Map<keyof PaymentPlatformData, string>([
  ['stripePaymentPlatformCount', 'Stripe'],
  ['applePaymentPlatformCount', 'Apple'],
  ['androidPaymentPlatformCount', 'Google'],
  ['freeTrialPaymentPlatformCount', 'Free trial'],
  ['orgPaysPaymentPlatformCount', 'Org pays'],
]);

interface PaymentPlatformChartProps {
  summedReport: SummedReport;
}

const PaymentPlatformChart: React.FC<PaymentPlatformChartProps> = ({ summedReport }) => {
  const { chartColors } = useChartTheme();

  const paidPricebooks = findPricebookReportsByType(summedReport).filter(pb =>
    isPaidProduct(pb.productType),
  );

  const filteredReport: SummedReport = {
    ...summedReport,
    pricebookReports: paidPricebooks,
  };

  const chartData = buildReportChartData(
    filteredReport,
    pricebookReport => getProductTypeKey(pricebookReport?.productType),
    paymentPlatformMap,
  );

  const dataSeries = Object.entries(chartData).map(([productType, data]) => ({
    data,
    color: chartColors[productType as keyof typeof chartColors],
    label: productType,
  }));

  return (
    <ChartBar
      title='Active users per payment platform'
      dataSeries={dataSeries}
      yAxisLabel='Count per payment platform'
      seriesLabel='Product type'
    />
  );
};

export default PaymentPlatformChart;
